const isIdentificator = (name) => {
  const regex = /^#([a-z0-9-_]+)$/gim;
  return regex.test(name);
};

export default isIdentificator;
